/* eslint-disable react/no-multi-comp */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { search, getPlaceLabel, stripSpecialChar, safeNumeral } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Link      from '@Pure/Link'
import Loader    from '@Pure/Loader'
import SearchBar from '@Pure/SearchBar'
import Image     from '@Pure/Image'

const { app, qwest, moment, numeral } = window;

export default class UpdateECProductAbondementPage extends Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			searched:
			{
				value: ''
			},

			products: [],
			selected_products: [],
			can_compute: true,

			abondement_value: '0',
			abondement_qty: 0,
			existing_abondements: [],

			form_data: { },
			status_messages: { },

			deleted: false
		};

		this.handleSearch          = this.handleSearch.bind(this);
		this.enableComputation     = this.enableComputation.bind(this);
		this.selectProduct         = this.selectProduct.bind(this);
		this.changeAbondementQty   = this.changeAbondementQty.bind(this);
		this.changeAbondementValue = this.changeAbondementValue.bind(this);
		this.handleSessionChange   = this.handleSessionChange.bind(this);
		this.handleUpdate          = this.handleUpdate.bind(this);
		this.handleGetProducts     = this.handleGetProducts.bind(this);
		this.handleDeletion        = this.handleDeletion.bind(this);

		this.handleOccurenceChange = handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'updatedProductAbondement',
			cb: component.handleUpdate
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.push(
		{
			event: 'deletedCMSContent',
			cb: component.handleDeletion
		});

		// lunrjs.com/guides/customising.html#pipeline-functions
		let normaliseSpelling = function (builder)
		{
			let pipelineFunction = function (token)
			{
				return token.update(function ()
				{
					return stripSpecialChar(token.toString());
				});
			};

		// Register the pipeline function so the index can be serialised
			window.lunr.Pipeline.registerFunction(pipelineFunction, 'normaliseSpelling')

		// Add the pipeline function to both the indexing pipeline and the
		// searching pipeline
			builder.pipeline.before(window.lunr.stemmer, pipelineFunction)
			builder.searchPipeline.before(window.lunr.stemmer, pipelineFunction)
		}

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		id = props.id || id;

		state.id = id;

		component.setState(
		{
			can_compute: true,
			id: id,
			get_loading: true,
			deleted: false
		});

		component.handleSessionChange();

		qwest.post('/fetch/list-products-for-abondement')
		.then(function (xhr, response)
		{
			const products = response.products || [];

			component.lunr = window.lunr(function ()
			{
				this.use(normaliseSpelling);

				this.ref('id');

				this.field('name', { boost: 10 });
				this.field('description');
				this.field('_artist');
				this.field('_places');
				this.field('_themes');

				products.forEach(function (doc)
				{
					this.add(doc);
				}, this);
			});

			component.db_products = _.cloneDeep(products);

			component.handleGetProducts();

			component.setState(
			{
				products: component.db_products,
				can_compute: true
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'updatedProductAbondement',
			cb: component.handleUpdate
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		app.delete(
		{
			event: 'deletedCMSContent',
			cb: component.handleDeletion
		});
	}

	handleUpdate (data)
	{
		const component = this, props = this.props, state = this.state;

		let abondement = state.existing_abondements.find(function (data, key)
		{
			if (data.id === data.abondement.id)
			{
				state.existing_abondements[key] = data.abondement;

				return true;
			}
		});

		component.setState(
		{
			existing_abondements: state.existing_abondements
		});
	}

	handleDeletion (deleted)
	{
		const component = this, props = this.props, state = this.state;

		if (deleted.id === state.id)
		{
			component.setState(
			{
				deleted: true
			});
		}
	}

	handleGetProducts ()
	{
		const component = this, props = this.props, state = this.state;

		if (!state.products_ids) return;

		if (!component.db_products) return;

		let products = state.products_ids.map(function (product_id)
		{
			let state_product = component.db_products
			.find(product => product.id === product_id);

			return _.cloneDeep(state_product);
		})
		.filter(data => Boolean(data));

		component.setState(
		{
			selected_products: products,
			get_loading: false
		});
	}

	handleSessionChange ()
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC && state.existing_abondements.length === 0)
		{
			qwest.post('/CMS/getAll',
			{
				model: 'abondement',
				filter_query: JSON.stringify(
				{
					EC: app.state.session.EC.id,
					type: 'product'
				})
			})
			.then(function (xhr, response)
			{
				let abondement = response.data.find(data => data.id === state.id);

				state.products_ids = _.cloneDeep(abondement.products);

				component.handleGetProducts();

				component.setState(
				{
					existing_abondements: response.data,
					products_ids: state.products_ids,

					abondement_value: numeral(safeNumeral(abondement.value))
					.format('0[.]00'),

					abondement_qty: abondement.qty,

					form_data:
					{
						'abondement-recurrence': abondement.recurrence
					}
				});
			})
			.catch(function (error, xhr, response)
			{
				app.ajaxRedirectLogin(response);

				console.error(error);
			});
		}
	}

	handleSearch (value, search)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			searched:
			{
				value: value
			},
			can_compute: value !== '' ? false : true
		});

	// Prevent to search each letter typed and wait a bit.
		if (component.computation)
		{
			window.clearTimeout(component.computation);

			component.computation = window.setTimeout(component.enableComputation, 320);
		}
		else
		{
			if (value !== '')
			{
				component.computation = window.setTimeout(component.enableComputation, 320);
			}
		}
	}

	enableComputation ()
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			can_compute: true
		});
	}

	selectProduct (e, product)
	{
		const component = this, props = this.props, state = this.state;

		let removed = false;

		state.selected_products = state.selected_products
		.filter(function (state_product)
		{
			if (state_product.id === product.id)
			{
				removed = true;

				return false;
			}

			return true;
		});

		if (removed === false)
		{
			state.selected_products.push(product);
		}

		component.setState(
		{
			selected_products: state.selected_products
		});
	}

	unSelectProduct (e, product)
	{
		const component = this, props = this.props, state = this.state;

		state.selected_products = state.selected_products
		.filter(function (state_product)
		{
			return state_product.id !== product.id;
		});

		component.setState(
		{
			selected_products: state.selected_products
		});
	}

	changeAbondementQty (e)
	{
		const component = this, props = this.props, state = this.state;
		const product   = state.product;

		if (e === 'less')
		{
			state.abondement_qty--;
		}
		else if (e === 'more')
		{
			state.abondement_qty++;
		}
		else if (e)
		{
			let qty = e.target.value;

			state.abondement_qty = Number(qty);
		}

		if (Number(state.abondement_qty) <= 0)
		{
			state.abondement_qty = 0;
		}

		component.setState(
		{
			abondement_qty: state.abondement_qty,
			abondement_value: state.abondement_value,
			abondement_loading: true
		});
	}

	changeAbondementValue (e)
	{
		const component = this, props = this.props, state = this.state;
		const product   = state.product;

		if (e)
		{
			let value = e.target.value.trim();

			state.abondement_value = value;
		}

		if (Number(state.abondement_value) < 0)
		{
			state.abondement_value = '0';
		}

		component.setState(
		{
			abondement_qty: state.abondement_qty,
			abondement_value: state.abondement_value,
			abondement_loading: true
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let search_results, searched_products = [], search_message;

		if (state.deleted === true)
		{
			let output =
			(
				<Layout history={ props.history } page_title="Abondement produit">

					<div className="page-content abondement-product-admin">

						<div className="o-content">

							<div className="c-message c-message--green">
								<div className="c-message__content">
									L'abondement a bien été supprimé.

									<Link className="c-link c-link--highlighted c-link--green u-margin-left-5"
										href="/espace-administrable/abondements-produit">
										Retourner à la liste des abondements
									</Link>
								</div>
							</div>

						</div>

					</div> { /* /page-content */ }

				</Layout>
			);

			return output;
		}

		if (state.can_compute && component.lunr)
		{
			search_results = component.lunr.search(stripSpecialChar(state.searched.value));

			searched_products = state.products
			.filter(function (product)
			{
				let find = search_results.find(data => data.ref === product.id);

				return typeof find !== 'undefined';
			});

			let existing_hidden = false;

			searched_products = searched_products.filter(function (product)
			{
				let has_already_abondement = false;

				state.existing_abondements.find(function (abondement)
				{
					if ((abondement.products || []).includes(product.id))
					{
						has_already_abondement = true;

						existing_hidden = true;

						return true;
					}
				});

				return has_already_abondement === false;
			});

			if (existing_hidden === true)
			{
				search_message =
				(
					<div className="o-content">
						<div className="c-message c-message--orange u-no-margin-top">
							<div className="c-message__content">
								Les produits déjà abondés sont masqués de la recherche.
							</div>
						</div>
					</div>
				);
			}
		}

		searched_products = searched_products.map(renderSearchProduct);

		let selected_products = state.selected_products.map(renderSelectedProduct);

		let search_loader;

		if (state.can_compute === false)
		{
			search_loader = <Loader className="c-loader abondement-search"
				bemit={ ['white', 'bg-primary'] } />;
		}

		let products_loader;

		if (state.get_loading === true)
		{
			products_loader =
			(
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			);
		}

		let abondement =
		(
			<div className="c-abondement">

				<div className="o-grid-2">

					<div className="o-grid__item">

						<div className="c-abondement-price">
							<strong className="u-margin-right-10">
								Montant de chaque abondement&nbsp;:
							</strong>

							<input type="text"
								className="c-qty__input"
								value={ state.abondement_value }
								onChange={ function (e)
									{ component.changeAbondementValue(e); } } />
							&nbsp;€
						</div>

						<div className="c-abondement-qty">

							<div className="c-qty c-qty--abondement">
								<strong>Quantité par membre&nbsp;:</strong>
								<button type="button" className="c-qty__less"
									onClick={ function (e)
										{ component.changeAbondementQty('less'); }
									}>
									-
								</button>

								<input type="text"
									className="c-qty__input"
									value={ state.abondement_qty }
									onChange={ function (e)
										{ component.changeAbondementQty(e); } } />

								<button type="button" className="c-qty__more"
									onClick={ function (e)
										{ component.changeAbondementQty('more'); } }>
									+
								</button>
							</div>

						</div>

					</div>

					<div className="o-grid__item">

						<div className="c-abondement-recurrence">

							<div className="c-abondement-recurrence-label">
								<strong>Récurrence&nbsp;:</strong>
							</div>

							<div className="c-abondement-recurrence-choices">

								<div className="c-checkbox-filter">

									<FormElement className="c-form-element c-form-element--inline"
										name="abondement-recurrence" type="radio"
										data={ state.form_data }
										label="Aucun ( valable une fois pour la quantité définie)" status={ state.status_messages }
										onChange={ component.handleOccurenceChange }
										radio_value="unique" checked={ true } />

								</div>

								<div className="c-checkbox-filter">

									<FormElement className="c-form-element c-form-element--inline"
										name="abondement-recurrence" type="radio"
										data={ state.form_data }
										label="Mensuel" status={ state.status_messages }
										onChange={ component.handleOccurenceChange }
										radio_value="month" />

								</div>

								<div className="c-checkbox-filter">

									<FormElement className="c-form-element c-form-element--inline"
										name="abondement-recurrence" type="radio"
										data={ state.form_data }
										label="Annuel" status={ state.status_messages }
										onChange={ component.handleOccurenceChange }
										radio_value="year" />

								</div>

							</div>

						</div>

					</div>

				</div>

			</div>
		);

		if (selected_products.length === 0)
		{
			selected_products =
			(
				<div className="o-content u-positioned">

					<div className="c-message c-message--green u-positioned">
						<div className="c-message__content">
							Aucun produit sélectionné pour le moment.
							{ products_loader }
						</div>
					</div>

				</div>
			);
		}
		else
		{
			selected_products =
			(
				<div className="o-grid-4">
					{ selected_products }
				</div>
			);
		}

		var output =
		(
			<Layout history={ props.history } page_title="Abondement produit">

				<div className="page-content abondement-product-admin">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">
								1. Sélection des produits à abonder
							</h2>
						</div>

						<div className="abondement-searchbar">
							<SearchBar className="c-searchbar c-searchbar--front u-no-margin-bottom"
								hide_btn={ true } placeholder="Recherche..." data={ [] }
								handleChange={ component.handleSearch }
								value={ state.searched.value }
							/>
						</div>

					</div>

					{ search_message }

					<div className="o-grid-4 u-positioned">
						{ searched_products }
						{ search_loader }
					</div>

					<div className="o-content u-margin-top-20">
						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">
								2. Règles de l'abondement
							</h2>
						</div>

						{ abondement }
					</div>

					<div className="o-content u-margin-top-20">

						<div className="c-subtitle c-subtitle u-no-margin-top">
							<h2 className="c-subtitle__txt">
								Produits sélectionnés
							</h2>
						</div>

					</div>

					{ selected_products }

					<div className="o-content u-margin-top-20">

						<button type="button" className="c-btn c-btn--extra"
							onClick={ function (e)
								{
									app.emit('open__UpdateAbondementModal',
									{
										products: state.selected_products.map(p => p.id),
										value: state.abondement_value,
										qty: state.abondement_qty,
										recurrence: state.form_data['abondement-recurrence'],
										id: state.id
									});
								}
							}>
							Mettre à jour l'abondement
						</button>

						<button type="button" className="c-btn c-btn--extra c-btn--red u-margin-left-15"
							onClick={ function (e)
								{
									app.emit('open__DeleteModal',
									{
										id: state.id,
										model: 'abondement',
										config:
										{
											get__deleteModalText: DeletedModalText
										}
									});
								}
							}>
							Supprimer cet abondement
						</button>
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;

		function renderSearchProduct (product)
		{
			return renderProduct(product, 'search');
		}

		function renderSelectedProduct (product)
		{
			return renderProduct(product, 'selection');
		}

		function renderProduct (product, type)
		{
			let image = (product.images || [])[0];

			if (image)
			{
				image =
				(
					<Image className="c-search-view-item__img" src={ image.url } />
				);
			}

			const places = !Array.isArray(product._places)
			? undefined
			: product._places.length === 1 ?getPlaceLabel(product._places[0])
			: product._places
			.filter(place => place.address?.city)
			.map(function (place, i)
			{
				let value = i > 0 ? ', ' : '';

				value += place.address.city;

				return value;
			});

			let selected;

			if (type === 'search')
			{
				selected = state.selected_products.find(data => data.id === product.id);

				selected = typeof selected === 'undefined' ? false : true;
			}

			let content =
			(
				<>
					{ image }

					<div className="c-search-view-item__content">
						<div className="c-search-view-item__title">
							{ product.name }
						</div>

						<div className="c-search-view-item__place">
							{ places }
						</div>
					</div>
				</>
			);

			let output =
			(
				<div className={ 'c-search-view-item' + (selected ? ' selected' : '') }
					onClick={ function (e) { component.selectProduct(e, product) } }
					style={ { cursor: 'pointer' } }>

					{ content }

				</div>
			);

			if (type === 'selection')
			{
				output =
				(
					<>
						<div className="c-search-view-item">
							{ content }
						</div>

						<div className="u-text-right u-overflow-hidden">
							<button type="button" className="c-btn c-btn--delete c-btn--collapsible"
								onClick={ function (e) { component.unSelectProduct(e, product); } }>
								Enlever de la sélection
							</button>
						</div>
					</>
				);
			}

			return <div className="o-grid__item" key={ product.id }>{ output }</div>;
		}
	}
}

function DeletedModalText ()
{
	return (
		<span>
			Êtes-vous sûr de vouloir supprimer cet abondement&nbsp;?
		</span>
	);
}